<div class="description">
  Set up additional backup steps so you can sign in even if your other options
  aren't available.
</div>

@for (option of verificationOptions; track $index) {
  <a [class.disabled-link]="option.isVerified"
     id="btnSetup_{{ getTypeCaps(option.verificationType) }}"
     href="./TypeEnrollment?verificationType={{ getTypeCaps(option.verificationType) }}">
    <div class="option">
      <div class="outer-column">
        <mat-icon>{{ getIcon(option.verificationType) }}</mat-icon>
      </div>

      <div class="option-text">
        <strong>{{ getOptionTitle(option.verificationType) }}</strong>

        <div class="secondary-text">
          @if (option.isVerified) {
            <div>
              You're already enrolled with {{ isAuthenticator(option.verificationType) ? 'an authenticator app.' : '' }}
            </div>
          }
          {{ getOptionDescription(option) }}
        </div>
      </div>

      <div class="outer-column">
        @if (option.isVerified) {
          <mat-icon color="primary">check_circle</mat-icon>
        }
      </div>
    </div>
  </a>
}

@if (canSkip) {
  <a id="btnSkipSetup"
     href="./SkipEnrollment">
    <div class="option">
      <div class="outer-column">
        <mat-icon>skip_next</mat-icon>
      </div>

      <div class="option-text">
        <strong>
          @if (hasVerifiedOption) {
            Continue to EZLynx
          } @else {
            Skip Verification
          }
        </strong>

        <div class="secondary-text">
          Skip for now and continue to EZLynx
        </div>
      </div>

      <div class="outer-column"></div>
    </div>
  </a>
}
